import store from '~/store'

export default (to, from, next) => {
  if (!store.getters['auth/check'] && store.getters['auth/token']) {
    next({ name: 'home' })
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./resources/js/middleware/guest.js